import type { Theme } from '@mui/material';

export function getUsageByMeterBaseColorByIndex(index: number, theme: Theme) {
  return [
    theme.palette.success,
    theme.palette.secondary,
    theme.palette.tertiary,
    theme.palette.error,
    theme.palette.warning,
  ][index % 5];
}